var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"hero":""}}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1),_vm._v(" "),_c('footer-links'),_vm._v(" "),_c('page-footer'),_vm._v(" "),_c('to-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }